import { Base } from '@studiometa/js-toolkit';
import getTrustpilot from '../utils/getTrustpilot.js';

/**
 * AvisClients component
 */
export default class AvisClients extends Base {
  /**
   * Component Configuration
   */
  static config = {
    name: 'AvisClients',
    refs: [
      'content',
      'tpl',
      'tplEmpty',
      'trustScore',
      'totalReviews',
      'starsContainer',
      'starsRating',
      'globalStarsRating',
    ],
  };

  /**
   * On mounted
   */
  async mounted() {
    const BUSINESS_UNITS = '641ac7df32bc3e5e965392d5';
    const apiUrlReviews = `https://api.trustpilot.com/v1/business-units/${BUSINESS_UNITS}/reviews`;
    const template = this.$refs.tpl;
    const emptyTemplate = this.$refs.tplEmpty;
    // Get trust score
    if (this.$root.score || this.$root.totalReviews) {
      this.$refs.trustScore.innerHTML = this.$root.score;
      this.$refs.totalReviews.innerHTML = this.$root.totalReviews;
    } else {
      const data = await getTrustpilot(this.$root.trustpilotApiUrl);
      this.$root.score = data.score.trustScore;
      this.$refs.trustScore.innerHTML = this.$root.score;
      this.$root.totalReviews = data.numberOfReviews.total;
      this.$refs.totalReviews.innerHTML = this.$root.totalReviews;
    }

    // Calculate the stars svg width
    const starsPercent = (this.$root.score * 100) / 5;
    if (this.$refs.starsRating) {
      this.$refs.starsRating.style.width = `${starsPercent}%`;
    } else {
      this.$refs.globalStarsRating.style.width = `${starsPercent}%`;
    }
    this.$refs.starsContainer.classList.remove('-translate-x-full');

    // Get reviews
    const reviewsData = await getTrustpilot(apiUrlReviews);
    if (reviewsData && reviewsData.reviews) {
      // Sort by date, keep only 3 and better and slice to only 3 items
      const sortedReviews = reviewsData.reviews.sort(
        (a, b) => new Date(b.createdAt) - new Date(a.createdAt),
      );
      const fiveStarReviews = sortedReviews.filter((review) => review.stars >= 3);
      const latestBestestReviews = fiveStarReviews.slice(0, 3);
      // To format the date
      const formatDate = (dateString) => {
        const options = { day: 'numeric', month: 'numeric', year: 'numeric' };
        return new Date(dateString).toLocaleDateString(undefined, options);
      };

      latestBestestReviews.forEach((review, index) => {
        // Add an empty div to reach the design goal
        if (index === 1) {
          const cloneEmpty = document.importNode(emptyTemplate.content, true);
          this.$refs.content.append(cloneEmpty);
        }
        // Clone the template content
        const clone = document.importNode(template.content, true);
        // Fill in the dynamic reviewsData
        const starsPercentCard = (review.stars * 100) / 5;
        clone.querySelector('.card-avis__stars').style.width = `${starsPercentCard}%`;
        const formattedDate = formatDate(review.createdAt);
        clone.querySelector('.card-avis__date').innerHTML = formattedDate;

        clone.querySelector('.card-avis__content').innerHTML = review.text;
        clone.querySelector('.card-avis__name').innerHTML = review.consumer.displayName;
        // Append the cloned content to the container
        this.$refs.content.append(clone);
      });
    }
  }
}
